import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-personal-web',
  templateUrl: './personal-web.component.html',
  styleUrls: ['./personal-web.component.scss']
})
export class PersonalWebComponent implements OnInit {

  safeSrc: SafeResourceUrl;
  isDesktop = false
  constructor(private sanitizer: DomSanitizer) {
    this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl("https://miguelchavezweb.com/");
  }

  ngOnInit() {
  }

}
